<template>
  <ChipLabelInput
    :value="value"
    :chip-placeholder="'{{pivot_label}}'"
    :chip-label="chipDisplayLabel"
    :chip-tooltip="hasPivot ? 'Pivot dimension value will be inserted at chip position' : ''"
    :show-add-button="hasPivot"
    @input="$emit('input', $event)" />
</template>

<script>
  import ChipLabelInput from '@/components/pdf_report/ChipLabelInput.vue'

  export default {
    name: 'PivotLabelInput',
    components: { ChipLabelInput, },
    props: {
      value: {
        type: String,
        default: '',
      },
      hasPivot: {
        type: Boolean,
        default: true,
      },
      pivotLabel: {
        type: String,
        default: '',
      },
    },
    computed: {
      chipDisplayLabel () {
        return this.pivotLabel ? `${this.pivotLabel} Label` : 'Dimension Pivot Label'
      },
    },
  }
</script>
